// app/assets/javascripts/attendance_charts.js - VERSÃO OTIMIZADA COM VENDEDOR
import axios from "axios";
import {
  enableSelect,
  disableSelect,
  clearSelectElTarget,
  clearEl,
} from "./attendance_concerns";

// Cache para armazenar dados já carregados
const dataCache = {
  groups: new Map(),
  dealers: new Map(),
  sellers: new Map(),
};

// Debounce para evitar múltiplas requisições
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const fnMain = () => {
  const companyEl = document.querySelector("#attendance_charts_company_id_eq");
  const groupEl = document.querySelector("#attendance_charts_dealer_group_id_eq");
  const dealerEl = document.querySelector("#attendance_charts_dealer_id_eq");
  const sellerEl = document.querySelector("#attendance_charts_seller_id_eq");

  if (companyEl || groupEl || dealerEl) {

    const BASE_URL = "searches";

    // Flag para evitar loops de atualização
    let isUpdating = false;

    const init = () => {
      // Inicialização mais eficiente
      const urlParams = new URLSearchParams(window.location.search);
      const companyId = urlParams.get('q[company_id_eq]');
      const groupId = urlParams.get('q[dealer_group_id_eq]');
      const dealerId = urlParams.get('q[dealer_id_eq]');
      const sellerId = urlParams.get('q[seller_id_eq]');

      // Se há parâmetros na URL, carrega os dados em paralelo quando possível
      if (companyId) {
        loadInitialDataOptimized(companyId, groupId, dealerId, sellerId);
      } else {
        // Estado inicial
        disableSelect(groupEl);
        disableSelect(dealerEl);
        if (sellerEl) disableSelect(sellerEl);
        clearSelectElTarget(groupEl, "Selecione primeiro o Grupo");
        clearSelectElTarget(dealerEl, "Selecione primeiro a Empresa");
        if (sellerEl) clearSelectElTarget(sellerEl, "Selecione primeiro a Revenda");
      }

      // Adiciona handlers com debounce
      companyEl.addEventListener("change", debounce(handleCompanyChange, 300));
      groupEl.addEventListener("change", debounce(handleGroupChange, 300));
      dealerEl.addEventListener("change", debounce(handleDealerChange, 300));
    };

    const loadInitialDataOptimized = async (companyId, groupId, dealerId, sellerId) => {
      try {
        // Mostra loading
        showLoading(groupEl, "Carregando empresas...");

        // Carrega grupos
        const groups = await fetchGroups(companyId);

        if (groups.length > 0) {
          updateSelectOptions(groupEl, groups, groupId, "Todas");

          // Se tem grupo selecionado, carrega dealers em paralelo
          if (groupId) {
            showLoading(dealerEl, "Carregando revendas...");
            const dealers = await fetchDealers(groupId);
            updateSelectOptions(dealerEl, dealers, dealerId, "Todas");

            // Se tem dealer selecionado, carrega vendedores
            if (dealerId && sellerEl) {
              showLoading(sellerEl, "Carregando vendedores...");
              const sellers = await fetchSellers(dealerId);
              updateSelectOptions(sellerEl, sellers, sellerId, "Todos");
            }
          }
        }
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
        handleLoadError(groupEl, "Erro ao carregar empresas");
      }
    };

    const fetchGroups = async (companyId) => {
      // Verifica cache primeiro
      if (dataCache.groups.has(companyId)) {
        return dataCache.groups.get(companyId);
      }

      try {
        const response = await axios.get(`${BASE_URL}/groups`, {
          params: { 'q[company_id_eq]': companyId },
          timeout: 5000 // Timeout de 5 segundos
        });

        const groups = response.data.groups || [];
        dataCache.groups.set(companyId, groups);
        return groups;
      } catch (error) {
        console.error('Erro ao buscar grupos:', error);
        throw error;
      }
    };

    const fetchDealers = async (groupId) => {
      // Verifica cache primeiro
      if (dataCache.dealers.has(groupId)) {
        return dataCache.dealers.get(groupId);
      }

      try {
        const response = await axios.get(`${BASE_URL}/dealers`, {
          params: { 'q[group_id_eq]': groupId },
          timeout: 5000
        });

        const dealers = response.data.dealers || [];
        dataCache.dealers.set(groupId, dealers);
        return dealers;
      } catch (error) {
        console.error('Erro ao buscar revendas:', error);
        throw error;
      }
    };

    const fetchSellers = async (dealerId) => {
      // Verifica cache primeiro
      if (dataCache.sellers.has(dealerId)) {
        return dataCache.sellers.get(dealerId);
      }

      try {
        const response = await axios.get(`${BASE_URL}/sellers`, {
          params: { 'q[dealer_id_eq]': dealerId },
          timeout: 5000
        });

        const sellers = response.data.sellers || [];
        dataCache.sellers.set(dealerId, sellers);
        return sellers;
      } catch (error) {
        console.error('Erro ao buscar vendedores:', error);
        throw error;
      }
    };

    const updateSelectOptions = (selectEl, items, selectedId, defaultText) => {
      if (isUpdating) return;

      isUpdating = true;

      // Constrói todas as options de uma vez (muito mais rápido)
      const options = [`<option value="">${defaultText}</option>`];

      items.forEach(item => {
        const selected = item.id == selectedId ? 'selected' : '';
        options.push(`<option value="${item.id}" ${selected}>${item.name}</option>`);
      });

      // Atualiza o DOM uma única vez
      selectEl.innerHTML = options.join('');
      enableSelect(selectEl);

      // Atualiza selectpicker usando a forma correta
      refreshSelectPicker(selectEl);
      isUpdating = false;
    };

    // Função auxiliar para refresh correto do selectpicker
    const refreshSelectPicker = (selectEl) => {
      if (!selectEl) return;

      try {
        // Usa a forma específica de acessar o selectpicker
        let [refEl] = Object.values(selectEl).filter(a => a?.liveSearch && a);
        if (refEl && refEl.selectpicker) {
          // Usa setTimeout para evitar conflitos de renderização
          setTimeout(() => {
            refEl.selectpicker.refresh();
          }, 0);
        }
      } catch (error) {
        console.warn('Erro ao atualizar selectpicker:', error);
        // Fallback para método tradicional se houver erro
        if ($(selectEl).data('selectpicker')) {
          $(selectEl).selectpicker('refresh');
        }
      }
    };

    const showLoading = (selectEl, message) => {
      selectEl.innerHTML = `<option value="">${message}</option>`;
      disableSelect(selectEl);
    };

    const handleLoadError = (selectEl, message) => {
      clearSelectElTarget(selectEl, message);
      disableSelect(selectEl);
    };

    const handleCompanyChange = async function () {
      const companyId = companyEl.value;

      // Limpa os selects dependentes
      clearSelectElTarget(groupEl, "Selecione a Empresa");
      clearSelectElTarget(dealerEl, "Selecione a Revenda");
      if (sellerEl) clearSelectElTarget(sellerEl, "Selecione o Vendedor");
      disableSelect(groupEl);
      disableSelect(dealerEl);
      if (sellerEl) disableSelect(sellerEl);

      if (!companyId) {
        return;
      }

      try {
        showLoading(groupEl, "Carregando empresas...");
        const groups = await fetchGroups(companyId);

        if (groups.length > 0) {
          updateSelectOptions(groupEl, groups, null, "Todas");
        } else {
          handleLoadError(groupEl, "Nenhuma empresa encontrada");
        }
      } catch (error) {
        handleLoadError(groupEl, "Erro ao carregar empresas");
      }
    };

    const handleGroupChange = async function () {
      const groupId = groupEl.value;

      // Limpa selects dependentes
      clearSelectElTarget(dealerEl, "Selecione a Revenda");
      if (sellerEl) clearSelectElTarget(sellerEl, "Selecione o Vendedor");
      disableSelect(dealerEl);
      if (sellerEl) disableSelect(sellerEl);

      if (!groupId) {
        return;
      }

      try {
        showLoading(dealerEl, "Carregando revendas...");
        const dealers = await fetchDealers(groupId);
        if (dealers.length > 0) {
          updateSelectOptions(dealerEl, dealers, null, "Todas");
        } else {
          handleLoadError(dealerEl, "Nenhuma revenda encontrada");
        }
      } catch (error) {
        handleLoadError(dealerEl, "Erro ao carregar revendas");
      }
    };

    const handleDealerChange = async function () {
      // Se não existe o select de vendedor, não faz nada
      if (!sellerEl) return;

      const dealerId = dealerEl.value;

      // Limpa select de vendedores
      clearSelectElTarget(sellerEl, "Selecione o Vendedor");
      disableSelect(sellerEl);

      if (!dealerId) {
        return;
      }

      try {
        showLoading(sellerEl, "Carregando vendedores...");
        const sellers = await fetchSellers(dealerId);

        if (sellers.length > 0) {
          updateSelectOptions(sellerEl, sellers, null, "Todos");
        } else {
          handleLoadError(sellerEl, "Nenhum vendedor encontrado");
        }
      } catch (error) {
        handleLoadError(sellerEl, "Erro ao carregar vendedores");
      }
    };

    // Limpa cache quando necessário (ex: a cada 5 minutos)
    setInterval(() => {
      dataCache.groups.clear();
      dataCache.dealers.clear();
      dataCache.sellers.clear();
    }, 300000); // 5 minutos

    init();
  }
};

// Inicialização otimizada
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fnMain);
  document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('[data-card-id]');

    // Observer para animar quando entra na viewport
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const card = entry.target;
          animateCard(card);
          observer.unobserve(card);
        }
      });
    }, observerOptions);

    cards.forEach(card => {
      observer.observe(card);
    });

    function animateCard(card) {
      const targetValue = parseInt(card.dataset.cardValue) || 0;
      const targetPercent = parseInt(card.dataset.cardPercent) || 0;

      // Anima número principal
      const valueEl = card.querySelector('.value-number');
      if (valueEl) {
        animateNumber(valueEl, 0, targetValue, 800);
      }

      // Anima porcentagem
      const percentEl = card.querySelector('.percent-value');
      if (percentEl) {
        animateNumber(percentEl, 0, targetPercent, 800, '%');
      }

      // Anima barra de progresso
      const progressBar = card.querySelector('.progress-bar');
      if (progressBar) {
        setTimeout(() => {
          progressBar.style.width = targetPercent + '%';
        }, 100);
      }
    }

    function animateNumber(element, start, end, duration, suffix = '') {
      const startTime = performance.now();

      function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Easing
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.floor(start + (end - start) * easeProgress);

        element.textContent = currentValue.toLocaleString('pt-BR') + suffix;

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          element.textContent = end.toLocaleString('pt-BR') + suffix;
        }
      }

      requestAnimationFrame(update);
    }
  });
} else {
  fnMain();
}